function cov_2kjyeu216s() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/input.ts";
  var hash = "8e4760d075fe5db7d8cb0a491f7cc0205d28e9e0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/input.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 44
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "1": {
        start: {
          line: 35,
          column: 42
        },
        end: {
          line: 35,
          column: 55
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8e4760d075fe5db7d8cb0a491f7cc0205d28e9e0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2kjyeu216s = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2kjyeu216s();
import { fontSizesNamedWithUnits, radii, spaceWithUnits } from "../foundations/index.mjs";
import { colors } from "../foundations/colors.mjs";
var baseStyle = (cov_2kjyeu216s().s[0]++, {
  boxSizing: 'border-box',
  textOverflow: 'ellipsis',
  transition: 'color 0.3s ease',
  fontSize: fontSizesNamedWithUnits.s1,
  width: '100%',
  border: "2px solid ".concat(colors.neutrals40),
  borderRadius: radii.roundedSquare,
  padding: spaceWithUnits[4],
  _placeholder: {
    color: colors.neutrals90,
    opacity: 1
  },
  _disabled: {
    bgcolor: colors.neutrals10,
    color: colors.neutrals70,
    cursor: 'not-allowed',
    _placeholder: {
      color: colors.neutrals70
    }
  },
  _focus: {
    outline: 'none',
    border: "2px solid ".concat(colors.neutrals100)
  },
  _invalid: {
    border: "2px solid ".concat(colors.red50)
  }
});
var input = (cov_2kjyeu216s().s[1]++, {
  baseStyle: baseStyle
});
export default input;